// extracted by mini-css-extract-plugin
export default {"headMark":"HeadMark_headMark__MNzG7","isActiveHeadMark":"HeadMark_isActiveHeadMark__SqBGh"};